// @flow
import React from "react";
import { Grid, Row, Col, Thumbnail } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Gallery } from "../../components/Gallery";

const greyColor = {
  backgroundColor: "#5d5e60"
};

class SectionGallery extends React.Component {
  render() {
    const images = [];

    for (let index = 8; index < 12; index++) {
      images.push(`/gallery/${(index + 1).toString()}.jpg`);
    }

    return (
      <div id="gallery" style={greyColor}>
        <div style={{ color: "#e7e7e7", display: "flex", justifyContent: "center" }}>
          <h2>Gallery</h2>
        </div>
        <Gallery images={images} />
        <div style={{ color: "white", display: "flex", justifyContent: "flex-end" }}>
          <Link to="/products"><div style={{ padding: "10px", marginRight: "10px", marginBottom: "10px", backgroundColor: "#f5f5f5" }} >See More</div></Link>
        </div>
      </div>
    );
  }
}

export default SectionGallery;



// WEBPACK FOOTER //
// ./src/pages/home/SectionGallery.js